const ONE_MINUTE_IN_MILLISECONDS = 60000
const ONE_HOUR_IN_MINUTES = 60
const ONE_DAY_IN_MINUTES = 1440

export const getFormattedRelativeTime = (dateString: string) => {
  const now = new Date()
  const date = new Date(dateString)

  const diff = now.getTime() - date.getTime()
  const minutes = Math.floor(diff / ONE_MINUTE_IN_MILLISECONDS)

  const formatter = new Intl.RelativeTimeFormat('en-US', { numeric: 'auto', style: 'short' })

  const format = (value: number, unit: Intl.RelativeTimeFormatUnit) => {
    return formatter.format(value, unit).replace('.', '').replace(' hr', 'h').replace(' min', 'm').replace(' day', 'd')
  }

  if (minutes < ONE_HOUR_IN_MINUTES) {
    return format(-minutes, 'minute')
  }

  if (minutes < ONE_DAY_IN_MINUTES) {
    const hours = Math.floor(minutes / ONE_HOUR_IN_MINUTES)
    return format(-hours, 'hour')
  }

  const days = Math.floor(minutes / ONE_DAY_IN_MINUTES)

  return format(-days, 'day')
}
